import type { AnimationRadioOption } from './AnimationRadioGroup';

export type AnimationDirection = 'left' | 'up' | 'down' | 'right';
export type AnimationDuration =
    | '3s'
    | '2s'
    | '1s'
    | '09s'
    | '08s'
    | '07s'
    | '06s'
    | '05s'
    | '04s'
    | '03s'
    | '02s'
    | '01s';
export type AnimationDelay = 'no-delay' | AnimationDuration;
export type AnimationLooping = 'one-time' | 'loop' | 'restart';
export type AnimationEasing = 'linear' | 'ease' | 'ease-in' | 'ease-out' | 'ease-in-out';
export type AnimationRepeat = 'infinite' | 'no-repeat' | 'repeat-1' | 'repeat-2' | 'repeat-3';

export const directionOptions: readonly AnimationRadioOption<AnimationDirection>[] = [
    { value: 'left', label: 'left' },
    { value: 'up', label: 'up' },
    { value: 'down', label: 'down' },
    { value: 'right', label: 'right' },
];

export const durationOptions: readonly AnimationRadioOption<AnimationDuration>[] = [
    { value: '3s', label: '3s' },
    { value: '2s', label: '2s' },
    { value: '1s', label: '1s' },
    { value: '09s', label: '09s' },
    { value: '08s', label: '08s' },
    { value: '07s', label: '07s' },
    { value: '06s', label: '06s' },
    { value: '05s', label: '05s' },
    { value: '04s', label: '04s' },
    { value: '03s', label: '03s' },
    { value: '02s', label: '02s' },
    { value: '01s', label: '01s' },
];

export const delayOptions: readonly AnimationRadioOption<AnimationDelay>[] = [
    { value: 'no-delay', label: 'no delay' },
    ...durationOptions.map(option => ({
        value: option.value,
        label: `d-${option.label}`,
    })),
];

export const loopingOptions: readonly AnimationRadioOption<AnimationLooping>[] = [
    { value: 'one-time', label: 'one time' },
    { value: 'loop', label: 'loop' },
    { value: 'restart', label: 'restart' },
];

export const easingOptions: readonly AnimationRadioOption<AnimationEasing>[] = [
    { value: 'linear', label: 'linear' },
    { value: 'ease', label: 'ease' },
    { value: 'ease-in', label: 'ease-in' },
    { value: 'ease-out', label: 'ease-out' },
    { value: 'ease-in-out', label: 'ease-in-out' },
];

export const repeatOptions: readonly AnimationRadioOption<AnimationRepeat>[] = [
    { value: 'infinite', label: 'infinite' },
    { value: 'no-repeat', label: 'no repeat' },
    { value: 'repeat-1', label: 'repeat-1' },
    { value: 'repeat-2', label: 'repeat-2' },
    { value: 'repeat-3', label: 'repeat-3' },
];
